var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"work-order-maintenance"},[_c('keep-alive',{attrs:{"exclude":"MaintenanceWorkOrderCreate,MaintenanceWorkOrderDetail"}},[_c('router-view',{staticClass:"work-order-maintenance-container"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }